import { Check } from "lucide-react";

export default function Stepper({
  steps,
  currentStep,
  onStepChange,
  canGoToStep = () => true,
}) {
  return (
    <nav aria-label="Progress" className="overflow-x-auto">
      <ol className="flex min-w-max items-center gap-2">
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;
          const isClickable = !isCurrent && canGoToStep(index);

          return (
            <li key={step.id} className="flex items-center gap-2">
              {index > 0 && (
                <span
                  aria-hidden="true"
                  className={`h-px w-8 ${
                    isCompleted || isCurrent
                      ? "bg-(--brand-primary)"
                      : "bg-(--border-strong)"
                  }`}
                />
              )}
              <button
                type="button"
                onClick={() => isClickable && onStepChange(index)}
                disabled={!isClickable && !isCurrent}
                aria-current={isCurrent ? "step" : undefined}
                className={`inline-flex items-center gap-2 rounded-full border-0 bg-transparent px-2 py-1 text-sm transition-colors ${
                  isClickable ? "cursor-pointer" : "cursor-default"
                } ${
                  isCurrent
                    ? "font-semibold text-(--brand-primary)"
                    : isCompleted
                      ? "font-medium text-(--text-primary)"
                      : "text-(--text-muted)"
                }`}
              >
                <span
                  aria-hidden="true"
                  className={`inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${
                    isCurrent
                      ? "bg-(--brand-primary) text-(--brand-primary-contrast)"
                      : isCompleted
                        ? "bg-(--pastel-violet) text-(--brand-primary)"
                        : "border border-(--border-strong) text-(--text-muted)"
                  }`}
                >
                  {isCompleted ? (
                    <Check size={14} strokeWidth={2.5} />
                  ) : (
                    index + 1
                  )}
                </span>
                <span className="whitespace-nowrap">{step.label}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
